export function isText (value: unknown): value is string {
    return typeof value === 'string' && value.trim().length > 0;
}
